import axios from '@/service/axios';

const NICE_API = '/api/nice';

export const niceApi = {
  userCheckApi() {
    return axios.post(`${NICE_API}/v3/userCheck`);
  },
};
